// @ts-nocheck
import React, { FC, useEffect, useState, useMemo, memo, useCallback, useRef } from 'react';
import {Nullable, Project, PageModel, API, GetProjectsByFilterProps} from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { FInter, FlexBox, useIsMobile, useScrollingState } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from "react-redux";
import { GridWrapperNew, ProjectsGridNew } from '../../shared/components/grids';
import { useProjectsList } from '../../shared/hooks/api/useProjectsByFilter';
import { Pagination } from '../../shared/components/pagination';
import ProjectCardNew from '../../shared/components/projectCard/projectCardNew';
import { computeProject, computeProjectMapTile } from '../../shared/helpers/types/computed/ComputedProject';
import { bProject } from '../utils';
import { useModal } from '../modules';
import useQueryState from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { useFastScrolling } from 'shared/hooks/useFastScrolling';
import { AppTester } from "supporting";
import { InfinityProjectsSelector, InfinityProjectsActions } from '../../shared/reducers/InfinityProjectsNew';

import { 
  fetchInfiniteProjects, 
  fetchInfiniteProjectsMore, 
  fetchInfiniteProjectsWithUpdate 
} from '../../shared/actions/infinityProjectsActionsNew';
import { BookCard } from '_deziiign/books/core/components/bookCard';
import { computeBook, computeBookProject } from '_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard } from 'shared/components/SkeletonCard/SkeletonCard';
import { ProjectDelegate } from 'project-delegate';
import { ONLINES_PROJECT_ORDER_INDEX } from "../../shared/pages/explore/constants";
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';


const PROJECTS_COUNT_FOR_OFFSET = 20;
const PAGE_COUNT_STARTS = 1;
const PAGE_WHICH_UPLOAD_ENDS = 4;
const PAGE_WHICH_UPLOAD_ENDS_MOB = 3;
const NULLABLE_OFFSET = 0;

export const StyledLoading = styled.div`
    margin-bottom: 40px;
    padding: 10px;
    font-size: 60px;
    line-height: 1;
    color: white;
    text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const isFilterChanged = (v: any, k: any, entity: string) => {
  return v && k && v[entity] && (k[entity] === undefined || (k[entity] && v[entity][0] !== k[entity][0]))
}

type Tabs = {
  [key: string]: string[] | string | null;
}

export interface ProjectsButchControllerProps<T = Project> {
  filter: GetProjectsByFilterProps;
  date: number;
  onProjectsLoaded?: (projects: T[]) => void;
  selectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  clearProjects?: () => void,
  setProjectCount?: (count: any) => void,
  linkPrefix?: string;
  isInfinityNeed?: boolean;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?:boolean;
  columns?: number;
  isUnload?: boolean;
  courseLoading?: boolean;
  preloadedTabs?: Tabs[];
  currentTab?: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  disableFilterCheck?: boolean;
  showCompetitionPoint?: boolean;
  isTeamProjects?: boolean;
  withoutQueryParams?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  isMainPage?: boolean;
  isTagPage?: boolean;
}

export const ProjectsButchController: FC<ProjectsButchControllerProps> = memo(({
  filter,
  date,
  onProjectsLoaded = () => undefined,
  isLoading,
  courseLoading,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  selectedProjects = [],
  isParticipate = [],
  clearProjects,
  setProjectCount,
  projectsCount,
  linkPrefix,
  isInfinityNeed,
  isSelectRightNeed,
  columns,
  isUnload,
  isPageWithoutTabs,
  preloadedTabs,
  contextName,
  currentTab,
  disableFilterCheck,
  showCompetitionPoint,
  isTeamProjects,
  withoutQueryParams,
  canMakeImageForTeam,
  isMainPage,
  isTagPage
}) => {
  const designer = useProfile();
  const theme = useTheme();

  const [{ /*page: currentPage = 1,*/ teachersOnly }/*, setQueryParams*/] = useQueryState();

  const [ currentPage, setPage] = useState(1);

  const setQueryParams = useCallback(({ page }: any) => {
    setPage(page);
  }, []);

  const [temp, setTemp] = useState(0);
  const dispatch = useDispatch();
  const [prevStringData, setPrevStringData] = useState('');
  const [filterType, setFilterType] = useState<number>();
  const { show } = useModal();
  const [refresh, setRefresh] = useState<boolean>(false);
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isSortedByNotModerated = useMemo(
    () => Boolean(isTagPage && filter?.notModerated),
    [isTagPage, filter?.notModerated]
  );

  // const st = useSelector((state) => state);
  // console.log(st)

  const { t, i18n } = useTranslation();
 
  const infScrollRef = useRef<any>(null);
  const tabRef = useRef<any>(null);
  const scrollTop = () => window.scrollTo(0 , 0);

  const infinityProjects = useSelector(InfinityProjectsSelector)?.data;
  const infinityProjectsPaging = useSelector(InfinityProjectsSelector)?.paging;
  const infinityProjectsFilter= useSelector(InfinityProjectsSelector)?.filter;
  const infinityProjectsPreloadData = useSelector(InfinityProjectsSelector)?.preloadData;
  const infinityProjectsPagingList = useSelector(InfinityProjectsSelector)?.pagingList;
  const isPreloadLoading = useSelector(InfinityProjectsSelector)?.isTabsLoading;
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const infinityProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isFinalPage = useSelector(InfinityProjectsSelector)?.isFinalPage;
  // const isNeedShowPreload = useSelector(InfinityProjectsSelector)?.isNeedShowPreload;

  const isStartPage = useMemo(() => (currentPage && Number(currentPage) === PAGE_COUNT_STARTS), [currentPage])
  const isNeedUpdatePreload = useMemo(
    () => ( refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);
  // const isNeedShowPreload = useMemo(() => (isStartPage ),[refresh, currentPage, isStartPage])
  const isNeedUpdMore = useMemo(
    () => ( refresh && Number(currentPage) > PAGE_COUNT_STARTS), [refresh, currentPage])
  const isBackToStartPage = useMemo(() => (refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);

  /**
   * Фильтр проектов с предзагрузкой и без
   */
  const infinityProjectsWithPreload = useMemo(() => {
    if (isOnlines) {
      return [...infinityProjects]?.sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      });
    }

    if (isPageWithoutTabs || (isPageWithoutTabs && (isNeedUpdMore || isBackToStartPage))) {
      return infinityProjects;
    }
    if (currentTab && !isPreloadLoading) {
      const arr = infinityProjectsPreloadData[currentTab] ? infinityProjectsPreloadData[currentTab] : [];
        if (isStartPage || isNeedUpdatePreload || isBackToStartPage) return arr;
        if (isNeedUpdMore) return infinityProjects;
        else {
          // return isNeedShowPreload ? [...arr, ...infinityProjects] : infinityProjects;
          return [...arr, ...infinityProjects]
        }
    }
  }, [
    infinityProjects,
    infinityProjectsPreloadData,
    currentTab,
    isNeedUpdMore,
    // isNeedShowPreload,
    isPreloadLoading,
    isNeedUpdatePreload,
    isStartPage,
    isBackToStartPage,
    isPageWithoutTabs,
   ])

  const teachersPrev = useRef<any>();

  const additionalFilter = useMemo(() => {
    return {
      page: currentPage
    }
  }, [currentPage ]);


  const projectsRequest = useMemo(() => ({ ...filter, ...additionalFilter }), [filter, additionalFilter]);

  const tExtra = useMemo(() => date + temp, [date, temp]);

  const [projects, isProjectsLoading, , projectsPaging] = useProjectsList(projectsRequest, i18n.language, tExtra, isInfinityNeed, isTeamProjects);

  const [fastScrolling, setFastScrolling] = useFastScrolling(infScrollRef?.current);

  useEffect(() => () => clearProjects && clearProjects(), [clearProjects]);


  useEffect(() => {
    if (!isStartPage && refresh) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(false)))
    }
    if (isBackToStartPage) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(true)))
    }
  }, [isStartPage, refresh, dispatch, isBackToStartPage])


  useEffect(() => {
    //@ts-ignore
    const stringData = JSON.stringify(isInfinityNeed ? infinityProjectsWithPreload : projects?.data)

    if(!prevStringData || prevStringData !== stringData) {
      setPrevStringData(stringData)
      //@ts-ignore
      onProjectsLoaded(isInfinityNeed ? infinityProjectsWithPreload : projects?.data);
      isLoading && isLoading(false)
    }
    if (setProjectCount) {
      if (isTagPage) {
        setProjectCount(infinityProjectsPagingList?.path?.count)
        return; 
      }
      //@ts-ignore
      isInfinityNeed ? setProjectCount(infinityProjectsWithPreload?.length) : setProjectCount(projectsPaging?.count);
    }
  }, [projects, infinityProjects, dispatch, isTagPage, infinityProjectsWithPreload, infinityProjectsPagingList, isInfinityNeed, onProjectsLoaded, isLoading, prevStringData, projectsPaging, setProjectCount, i18n.language]);

  //@ts-ignore
  const showInfinityScroll = useMemo(() => (isInfinityNeed && infinityProjectsWithPreload && infinityProjectsWithPreload?.length > 0), [isInfinityNeed, infinityProjectsWithPreload])

  const needAutoFetchProjectsMore = useMemo(() => (Number(currentPage) > (isMobile ? PAGE_WHICH_UPLOAD_ENDS_MOB : PAGE_WHICH_UPLOAD_ENDS)), [currentPage, isMobile]);

  // todo fix naming, seems like does the opposite
  const isCanLoadInfinityProjectsMore = useMemo(() => {
    // if (infinityProjectsPaging &&
    //     ((Number(currentPage) > infinityProjectsPaging?.pages) ||
    //     ((Number(currentPage) * PROJECTS_COUNT_FOR_OFFSET) >
    //     infinityProjectsPaging?.count))
    //   )
    // {
    //   return false;
    // }
    return isFinalPage || isOnlines;
  } , [infinityProjectsPaging, currentPage, isFinalPage])

  const filterChanged = useMemo(() => (
    !isProjectPage && (
      JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
      JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
      JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) || 
      JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      filter?.projectFilter !== infinityProjectsFilter?.projectFilter ||
      (isTagPage && 
        (
          (filter?.isContextIgnored !== infinityProjectsFilter?.isContextIgnored ) || 
          (filter?.approved !== infinityProjectsFilter?.approved) || 
          (filter?.notApproved !== infinityProjectsFilter?.notApproved) || 
          (filter?.notModerated !== infinityProjectsFilter?.notModerated) ||
          (filter?.moderatedBy !== infinityProjectsFilter?.moderatedBy) || 
          (filter?.createdFrom !== infinityProjectsFilter?.createdFrom) ||
          (filter?.createdTo !== infinityProjectsFilter?.createdTo) ||
          (filter?.publishedFrom !== infinityProjectsFilter?.publishedFrom) ||
          (filter?.publishedTo !== infinityProjectsFilter?.publishedTo)
          )
        )
      )
    ), [infinityProjectsFilter, filter, isProjectPage, isTagPage])

  const isPrevFiltersNotEquals  = useMemo(() => {
    if (isProjectPage) {
      return (
        JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
        JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
        JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) || 
        JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
        JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
        filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      ) 
    }   
  }, [infinityProjectsFilter, filter, isProjectPage])


  const isInitialNeeded = useMemo(() => (
    !isProjectPage && (
      isFilterChanged( filter, infinityProjectsFilter, 'contexts') ||
      isFilterChanged(filter, infinityProjectsFilter, 'globalTypes') ||
      filter?.requestContext !== infinityProjectsFilter?.requestContext ||
      isFilterChanged(filter, infinityProjectsFilter, 'requiredTagIds') ||
      infinityProjectsFilter?.projectFilter !== filter?.projectFilter ||
      (isTagPage && 
        (
          (filter?.tagIds?.[0] !== infinityProjectsFilter?.tagIds?.[0]) ||
          (filter?.isContextIgnored !== infinityProjectsFilter?.isContextIgnored ) || 
          (filter?.approved !== infinityProjectsFilter?.approved) || 
          (filter?.notApproved !== infinityProjectsFilter?.notApproved) || 
          (filter?.notModerated !== infinityProjectsFilter?.notModerated) ||
          (filter?.moderatedBy !== infinityProjectsFilter?.moderatedBy) || 
          (filter?.createdFrom !== infinityProjectsFilter?.createdFrom) ||
          (filter?.createdTo !== infinityProjectsFilter?.createdTo) ||
          (filter?.publishedFrom !== infinityProjectsFilter?.publishedFrom) ||
          (filter?.publishedTo !== infinityProjectsFilter?.publishedTo)
        )
      )
  )
    ), [infinityProjectsFilter, filter, isTagPage, isProjectPage])

  useEffect(() => {
    setFilterType(filter?.projectFilter);
    if (filterChanged) {
      if (!withoutQueryParams) setQueryParams({ page: 1 }, { replace: true })
      if (!isOnlines) {
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset()); //Убрать если будут проблемы
      }
      if (isTagPage) {
        dispatch(InfinityProjectsActions.clear());
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter({}))
        setTemp(Date.now());
      }
      dispatch(InfinityProjectsActions.setFilter(filter));
    } 
    if (isPrevFiltersNotEquals) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
    if (!disableFilterCheck) {
      setTemp(Date.now());
    }
  }, [filter, dispatch, i18n, isTagPage, filterChanged, currentTab, isPrevFiltersNotEquals, setQueryParams, withoutQueryParams])

  /**
   * Фикс бага @Artem
   */
  useEffect(() => {
    if (!isPreloadLoading && (currentTab || "") in (infinityProjectsPagingList || {})) {
      dispatch(InfinityProjectsActions.setPaging(infinityProjectsPagingList[currentTab]));
    } else if (tabRef?.current !== currentTab) {
      dispatch(InfinityProjectsActions.clearFinalPage());
    }
    tabRef.current = currentTab
  }, [currentTab, tabRef, isPreloadLoading, infinityProjectsPagingList])

  useEffect(() => {
    return () => {
      dispatch(InfinityProjectsActions.clearFinalPage());
    }
  }, [])

  /**
   * Начальная подгрузка
   */
  useEffect(() => {
    /**
     * Без табов
     */
    if (isInfinityNeed && isPageWithoutTabs && !isProjectPage) {
      if (isNeedUpdMore || isNeedUpdatePreload) {
        scrollTop();
        setRefresh(false)
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              isTagPage,
              // lang: i18n.language
            }
          )
        );
        return;
      }
      if ((isStartPage || isBackToStartPage) && !(isOnlines && infinityProjects?.length)) {
        dispatch(
          fetchInfiniteProjectsMore(
            {
              // lang: i18n.language,
              currentTab,
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              exceptions: true ,
              isTagPage,
              tabs: preloadedTabs,
              contextName,
              withoutTabs: isPageWithoutTabs
            }
          )
        );
      }
    }

    /**
     * С табами
     */
    if (isInfinityNeed && preloadedTabs && !isPageWithoutTabs) {

      if (isNeedUpdMore) {
        scrollTop();
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            { 
              page: currentPage,
              isTagPage,
              // lang: i18n.language
            }
          )
        );
      }
      if (isInitialNeeded || isBackToStartPage) {
        /**
         * Все очищаем
         */
        setRefresh(false);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        /*
         * запрашиваем прелоад проекты
         */
        dispatch(fetchInfiniteProjects({ 
          preload: preloadedTabs,
          page: currentPage,
          currentTab,
          isTagPage,
          // lang: i18n.language
        }));
        return;
        /**/
      } 
    }
  }, [
    isInitialNeeded,
    isNeedUpdMore,
    isStartPage,
    isTagPage, 
    isBackToStartPage,
    isNeedUpdatePreload, 
    dispatch,
    refresh, 
    isProjectPage, 
    currentPage, 
    i18n, 
    preloadedTabs, 
    isInfinityNeed,
    isPageWithoutTabs,
    contextName
  ])

  /**
   * Обновление при переключении табов
   */
  useEffect(() => {

    if (!isProjectPage && currentTab && !isOnlines) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
      dispatch(InfinityProjectsActions.clearProjects());
      dispatch(InfinityProjectsActions.clearOffset());
    }
  }, [dispatch, currentTab, isProjectPage])

  const setCurrentPage = (page: any) => { setQueryParams({ page }, { replace: true }) };

  useEffect(() => {
    if (
      (!teachersOnly && teachersPrev.current) || (teachersPrev.current && !teachersOnly)
    ) {
      setCurrentPage(1);
      dispatch(InfinityProjectsActions.clear())
      setFastScrolling(false);
    }
    teachersPrev.current = teachersOnly;
  }, [
    teachersOnly,
    dispatch,
    setCurrentPage,
    setFastScrolling 
  ])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if  (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjectsNext= useCallback(() => {
    // if (needAutoFetchProjectsMore) return false;
      setCurrentPage(!infinityProjectsPaging.offset ? 2 : infinityProjectsPaging.offset === 20 ? 3 : ((
        //@ts-ignore
        infinityProjectsPaging.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET) + PAGE_COUNT_STARTS
      );

      if (!isPageWithoutTabs) {
        setRefresh(false)
      }

      dispatch(fetchInfiniteProjectsMore({ 
        // lang : i18n.language,
        currentTab,
        tabs: preloadedTabs, 
        contextName,
        isTagPage, 
        withoutTabs: isPageWithoutTabs 
      }));
  }, [
    // needAutoFetchProjectsMore,
    infinityProjectsPaging,
    setCurrentPage,
    i18n,
    dispatch,
    isPageWithoutTabs,
    preloadedTabs,
    contextName
  ])

  // const ShowMoreButtonOrLoading = useMemo(() => {
  //   if( fastScrolling && needAutoFetchProjectsMore) {

  //     return (
  //       <ShowMoreWrapper 
  //         style={{ cursor: 'pointer' }}
  //         width={'80%'} 
  //         justify="center" 
  //         offsetBottom={24} 
  //         offsetTop={32}
  //         onClick={() => {
  //           setFastScrolling(false);
  //           fetchMoreProjects();
  //         }}
  //       >
  //         <FInter.TextBold 
  //           style={{ fontSize: '17px', whiteSpace: 'pre', userSelect: 'none' }} 
  //           color={theme.progressbar.colorBold}>
  //           {t('text.show_more')}
  //         </FInter.TextBold >
  //       </ShowMoreWrapper>
  //     )
  //   }

  //   return (
  //     <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
  //       <ProgressBar 
  //         text={t('text.loading')} 
  //         loading={true} 
  //         color={theme.progressbar.color} 
  //       />
  //     </FlexBox>
  //   )
  // }, [fastScrolling, setFastScrolling, t, fetchMoreProjects, theme, needAutoFetchProjectsMore])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!infinityProjectsLoading) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column'>
        <GridWrapperNew mobileColumns={2}>
          {new Array(8).fill('').map((_, index) => (
              <SkeletonCard key={index}/>
          ))}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar 
            text={t('text.loading')} 
            loading={true} 
            color={theme.progressbar.color} 
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, infinityProjectsLoading])


  const paging = useMemo(() => {
      return isInfinityNeed ? infinityProjectsPaging : projects?.paging
  }, [isInfinityNeed, infinityProjectsPaging, projects]);

  const sortedProjects = useMemo(() => isOnlines ? projects?.data?.sort((a, b) => {
    if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
      return 1;
    }
    if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
      return -1;
    }
    return 0;
  }) : projects?.data, [isOnlines, projects]);

  const localizedInfinityProjectsWithPreload = useMemo(() => {
    return infinityProjectsWithPreload ? API.toLang(infinityProjectsWithPreload, i18n.language) : []
  }, [infinityProjectsWithPreload, i18n.language])

  return (
    <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
      {!showInfinityScroll && (
        <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading || courseLoading} columns={columns}>
        {sortedProjects?.map((v: Nullable<Partial<Project<'Local'>>>) => {
          /**
           * Нурс попоросил убрать проект с онлайнс 
           */
          if (isOnlines && v?.projectId === "b1e7ff644881488c9d90508feb43aaec") {
            return false;
          }
          if (!v?.isBook) {
            return (
              <ProjectCardNew
                project={v as any}
                isSortedByNotModerated={isSortedByNotModerated}
                isModal={modal}
                withoutGoToProject={withoutGoToProject}
                onProjectClick={ modal ?
                  (projectId?: string, e?: any) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    if (!v?.isBook) {
                      show('project', { projectId: v?.projectId });
                    }
                  } : undefined }
                isSelectable={selectable}
                isEditable={
                  !isAgeyTomesh &&
                  ((v && designer && bProject?.isEditableFor(v as any, designer)) ||
                  bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any))
                }
                isRejected={ProjectDelegate.isRejectedProject(v)}
                key={v?.projectId}
                {...computeProject(v)}
                onShouldReload={() => setTemp(Date.now())}
                onSelect={onSelect}
                metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '')}
                selected={selectedProjects?.includes(v?.projectId ?? '')}
                alreadyProject={isAlreadyProject(v?.projectId)}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isSelectRightNeed={isSelectRightNeed}
                showCompetitionPoint={showCompetitionPoint}
                canMakeImageForTeam={canMakeImageForTeam}
              />
            );
        } else {
          const book = computeBookProject(v);
          return (
            <BookCard
              book={book as any}
              key={book?.bookId}
              {...computeBook(book)}
              onShouldReload={() => setTemp(Date.now())}
              linkPrefix={linkPrefix ? linkPrefix : undefined}
              isSortedByNotModerated={isSortedByNotModerated}
              onSelect={onSelect}
              selected={selectedProjects?.includes(v?.projectId ?? '')}
            />
          );
        }
      })}
      </ProjectsGridNew>
      )}

      {showInfinityScroll && (
        <InfiniteScroll
        //@ts-ignore
            dataLength={localizedInfinityProjectsWithPreload?.length}
            next={fetchMoreProjectsNext}
            hasMore={!isCanLoadInfinityProjectsMore}
            initialScrollY={0}
            scrollThreshold={0.9}
            loader={ShowMoreButtonOrLoading}
            ref={infScrollRef}
          >
            <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading || courseLoading} columns={columns}>
              {/*@ts-ignore*/}
              {localizedInfinityProjectsWithPreload?.map((v: Nullable<Partial<Project<'Local'>>>) => {
                if (!v?.isBook) {
                  return (
                    <ProjectCardNew
                      project={v as any}
                      isSortedByNotModerated={isSortedByNotModerated}
                      isModal={modal}
                      withoutGoToProject={withoutGoToProject}
                      onProjectClick={modal ?
                        (projectId?: string, e?: any) => {
                          e?.stopPropagation();
                          e?.preventDefault();
                          // show('project', { projectId: v?.projectId });
                        } : undefined }
                      isSelectable={selectable}
                      isEditable={
                        !isAgeyTomesh &&
                        ((v && designer && bProject.isEditableFor(v as any, designer)) ||
                        bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any))
                      }
                      isRejected={ProjectDelegate.isRejectedProject(v)}
                      key={v?.projectId}
                      {...computeProject(v)}
                      onShouldReload={() => setTemp(Date.now())}
                      onSelect={onSelect}
                      selected={selectedProjects?.includes(v?.projectId ?? '')}
                      alreadyProject={isAlreadyProject(v?.projectId)}
                      linkPrefix={linkPrefix ? linkPrefix : undefined}
                      showCompetitionPoint={showCompetitionPoint}
                      canMakeImageForTeam={canMakeImageForTeam}
                    />
                  );
                } else {
                  const book = computeBookProject(v);
                  return (
                    <BookCard
                      book={book as any}
                      key={book?.bookId}
                      {...computeBook(book)}
                      onShouldReload={() => setTemp(Date.now())}
                      linkPrefix={linkPrefix ? linkPrefix : undefined}
                      isSortedByNotModerated={isSortedByNotModerated}
                      onSelect={onSelect}
                      selected={selectedProjects?.includes(v?.projectId ?? '')}
                    />
                  );
                }
              })}
            </ProjectsGridNew>
        </InfiniteScroll>
      )}
      {isInfinityNeed && !isPageWithoutTabs && (
          <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={isPreloadLoading} />
      )}
      {/* {(isInfinityNeed && needAutoFetchProjectsMore) && (
        <ShowMoreProjectsBlock 
          onClick={() => {
            setFastScrolling(false);
            fetchMoreProjects();
          }} 
          hide={infinityProjectsLoading} 
        />
      )} */}
      {!isInfinityNeed && (
        <Pagination
          pages={paging?.pages ?? 0}
          page={Number(currentPage)}
          onPageChange={(page) => {
            setQueryParams({ page }, { replace: true });
            isInfinityNeed && setRefresh(true)
            isPageWithoutTabs && dispatch(
              InfinityProjectsActions.setIsProjectPage(false)
            );
            setTemp(Date.now());
            scrollTop();
          }}
          isCanLoadMore={currentPage < (paging?.pages ?? 0)}
          hidden={(!paging?.pages || paging?.pages === 1)}
        /> 
      )}
      {/* <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} /> */}
    </FlexBox>
  );
});
// @ts-nocheck
import React, { FC, useEffect, useState, useMemo, memo, useCallback, useRef } from 'react';
import {Nullable, Project, PageModel, API, GetProjectsByFilterProps} from '@brg/api';
import { useProfile, bProfile } from '@brg/auth';
import { FInter, FlexBox, useIsMobile, useScrollingState } from '@brg/ui';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from "react-redux";
import { GridWrapperNew, ProjectsGridNew } from '../../shared/components/grids';
import { useProjectsList } from '../../shared/hooks/api/useProjectsByFilter';
import { Pagination } from '../../shared/components/pagination';
import ProjectCardNew from '../../shared/components/projectCard/projectCardNew';
import { computeProject, computeProjectMapTile } from '../../shared/helpers/types/computed/ComputedProject';
import { bProject } from '../utils';
import { useModal } from '../modules';
import useQueryState from "../../shared/hooks/useQueryState";
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'shared/icons/Progress';
import styled, { useTheme } from 'styled-components';
import { useFastScrolling } from 'shared/hooks/useFastScrolling';
import { AppTester } from "supporting";
import { InfinityProjectsSelector, InfinityProjectsActions } from '../../shared/reducers/InfinityProjectsNew';

import { 
  fetchInfiniteProjects, 
  fetchInfiniteProjectsMore, 
  fetchInfiniteProjectsWithUpdate 
} from '../../shared/actions/infinityProjectsActionsNew';
import { BookCard } from '_deziiign/books/core/components/bookCard';
import { computeBook, computeBookProject } from '_deziiign/books/core/components/helper/types/computed/ComputedBook';
import { EmptyCardsLoading } from 'shared/components/CardsLoading/EmptyCards';
import { SkeletonCard } from 'shared/components/SkeletonCard/SkeletonCard';
import { ProjectDelegate } from 'project-delegate';
import { ONLINES_PROJECT_ORDER_INDEX } from "../../shared/pages/explore/constants";
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';


const PROJECTS_COUNT_FOR_OFFSET = 20;
const PAGE_COUNT_STARTS = 1;
const PAGE_WHICH_UPLOAD_ENDS = 4;
const PAGE_WHICH_UPLOAD_ENDS_MOB = 3;
const NULLABLE_OFFSET = 0;

export const StyledLoading = styled.div`
    margin-bottom: 40px;
    padding: 10px;
    font-size: 60px;
    line-height: 1;
    color: white;
    text-align: center;
`;

export const ShowMoreWrapper = styled(FlexBox)`
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${p => p.theme.progressbar.borderColor};
  border-radius: 3px;
  padding: 12px 48px;
`;

const OffsetBlock = styled.div<{ display: boolean }>`
  width: 100%;
  margin-top: 64px;
  display: ${p => p?.display ? 'inline-block' : 'none'};
`;

const isFilterChanged = (v: any, k: any, entity: string) => {
  return v && k && v[entity] && (k[entity] === undefined || (k[entity] && v[entity][0] !== k[entity][0]))
}

type Tabs = {
  [key: string]: string[] | string | null;
}

export interface ProjectsButchControllerProps<T = Project> {
  filter: GetProjectsByFilterProps;
  date: number;
  onProjectsLoaded?: (projects: T[]) => void;
  selectable?: boolean;
  onSelect?: (projectId: string) => void;
  withoutGoToProject?: boolean;
  selectedProjects?: string[];
  isParticipate?: string[];
  modal?: boolean;
  clearProjects?: () => void,
  setProjectCount?: (count: any) => void,
  linkPrefix?: string;
  isInfinityNeed?: boolean;
  projectsCount?: number;
  isLoading?: Function;
  isSelectRightNeed?:boolean;
  columns?: number;
  isUnload?: boolean;
  courseLoading?: boolean;
  preloadedTabs?: Tabs[];
  currentTab?: string;
  contextName?: string;
  isPageWithoutTabs?: boolean;
  disableFilterCheck?: boolean;
  showCompetitionPoint?: boolean;
  isTeamProjects?: boolean;
  withoutQueryParams?: boolean;
  isDisabled?: boolean;
  canMakeImageForTeam?: TOwnerRights;
  isMainPage?: boolean;
  isTagPage?: boolean;
}

export const ProjectsButchController: FC<ProjectsButchControllerProps> = memo(({
  filter,
  date,
  onProjectsLoaded = () => undefined,
  isLoading,
  courseLoading,
  selectable = false,
  modal = false,
  onSelect = () => undefined,
  withoutGoToProject,
  selectedProjects = [],
  isParticipate = [],
  clearProjects,
  setProjectCount,
  projectsCount,
  linkPrefix,
  isInfinityNeed,
  isSelectRightNeed,
  columns,
  isUnload,
  isPageWithoutTabs,
  preloadedTabs,
  contextName,
  currentTab,
  disableFilterCheck,
  showCompetitionPoint,
  isTeamProjects,
  withoutQueryParams,
  canMakeImageForTeam,
  isMainPage,
  isTagPage
}) => {
  const designer = useProfile();
  const theme = useTheme();

  const [{ /*page: currentPage = 1,*/ teachersOnly }/*, setQueryParams*/] = useQueryState();

  const [ currentPage, setPage] = useState(1);

  const setQueryParams = useCallback(({ page }: any) => {
    setPage(page);
  }, []);

  const [temp, setTemp] = useState(0);
  const dispatch = useDispatch();
  const [prevStringData, setPrevStringData] = useState('');
  const [filterType, setFilterType] = useState<number>();
  const { show } = useModal();
  const [refresh, setRefresh] = useState<boolean>(false);
  const isAgeyTomesh = AppTester.isAgeytomesh();
  const isOnlines = AppTester.isOnlines();
  const isMobile = useIsMobile();
  const isSortedByNotModerated = useMemo(
    () => Boolean(isTagPage && filter?.notModerated),
    [isTagPage, filter?.notModerated]
  );

  // const st = useSelector((state) => state);
  // console.log(st)

  const { t, i18n } = useTranslation();
 
  const infScrollRef = useRef<any>(null);
  const tabRef = useRef<any>(null);
  const scrollTop = () => window.scrollTo(0 , 0);

  const infinityProjects = useSelector(InfinityProjectsSelector)?.data;
  const infinityProjectsPaging = useSelector(InfinityProjectsSelector)?.paging;
  const infinityProjectsFilter= useSelector(InfinityProjectsSelector)?.filter;
  const infinityProjectsPreloadData = useSelector(InfinityProjectsSelector)?.preloadData;
  const infinityProjectsPagingList = useSelector(InfinityProjectsSelector)?.pagingList;
  const isPreloadLoading = useSelector(InfinityProjectsSelector)?.isTabsLoading;
  const isProjectPage = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const infinityProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isFinalPage = useSelector(InfinityProjectsSelector)?.isFinalPage;
  // const isNeedShowPreload = useSelector(InfinityProjectsSelector)?.isNeedShowPreload;

  const isStartPage = useMemo(() => (currentPage && Number(currentPage) === PAGE_COUNT_STARTS), [currentPage])
  const isNeedUpdatePreload = useMemo(
    () => ( refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);
  // const isNeedShowPreload = useMemo(() => (isStartPage ),[refresh, currentPage, isStartPage])
  const isNeedUpdMore = useMemo(
    () => ( refresh && Number(currentPage) > PAGE_COUNT_STARTS), [refresh, currentPage])
  const isBackToStartPage = useMemo(() => (refresh && Number(currentPage) === PAGE_COUNT_STARTS), [refresh, currentPage]);

  /**
   * Фильтр проектов с предзагрузкой и без
   */
  const infinityProjectsWithPreload = useMemo(() => {
    if (isOnlines) {
      return [...infinityProjects]?.sort((a, b) => {
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return 1;
        }
        if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
          return -1;
        }
        return 0;
      });
    }

    if (isPageWithoutTabs || (isPageWithoutTabs && (isNeedUpdMore || isBackToStartPage))) {
      return infinityProjects;
    }
    if (currentTab && !isPreloadLoading) {
      const arr = infinityProjectsPreloadData[currentTab] ? infinityProjectsPreloadData[currentTab] : [];
        if (isStartPage || isNeedUpdatePreload || isBackToStartPage) return arr;
        if (isNeedUpdMore) return infinityProjects;
        else {
          // return isNeedShowPreload ? [...arr, ...infinityProjects] : infinityProjects;
          return [...arr, ...infinityProjects]
        }
    }
  }, [
    infinityProjects,
    infinityProjectsPreloadData,
    currentTab,
    isNeedUpdMore,
    // isNeedShowPreload,
    isPreloadLoading,
    isNeedUpdatePreload,
    isStartPage,
    isBackToStartPage,
    isPageWithoutTabs,
   ])

  const teachersPrev = useRef<any>();

  const additionalFilter = useMemo(() => {
    return {
      page: currentPage
    }
  }, [currentPage ]);


  const projectsRequest = useMemo(() => ({ ...filter, ...additionalFilter }), [filter, additionalFilter]);

  const tExtra = useMemo(() => date + temp, [date, temp]);

  const [projects, isProjectsLoading, , projectsPaging] = useProjectsList(projectsRequest, i18n.language, tExtra, isInfinityNeed, isTeamProjects);

  const [fastScrolling, setFastScrolling] = useFastScrolling(infScrollRef?.current);

  useEffect(() => () => clearProjects && clearProjects(), [clearProjects]);


  useEffect(() => {
    if (!isStartPage && refresh) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(false)))
    }
    if (isBackToStartPage) {
      dispatch(dispatch(InfinityProjectsActions.setIsNeedShowPreload(true)))
    }
  }, [isStartPage, refresh, dispatch, isBackToStartPage])


  useEffect(() => {
    //@ts-ignore
    const stringData = JSON.stringify(isInfinityNeed ? infinityProjectsWithPreload : projects?.data)

    if(!prevStringData || prevStringData !== stringData) {
      setPrevStringData(stringData)
      //@ts-ignore
      onProjectsLoaded(isInfinityNeed ? infinityProjectsWithPreload : projects?.data);
      isLoading && isLoading(false)
    }
    if (setProjectCount) {
      if (isTagPage) {
        setProjectCount(infinityProjectsPagingList?.path?.count)
        return; 
      }
      //@ts-ignore
      isInfinityNeed ? setProjectCount(infinityProjectsWithPreload?.length) : setProjectCount(projectsPaging?.count);
    }
  }, [projects, infinityProjects, dispatch, isTagPage, infinityProjectsWithPreload, infinityProjectsPagingList, isInfinityNeed, onProjectsLoaded, isLoading, prevStringData, projectsPaging, setProjectCount, i18n.language]);

  //@ts-ignore
  const showInfinityScroll = useMemo(() => (isInfinityNeed && infinityProjectsWithPreload && infinityProjectsWithPreload?.length > 0), [isInfinityNeed, infinityProjectsWithPreload])

  const needAutoFetchProjectsMore = useMemo(() => (Number(currentPage) > (isMobile ? PAGE_WHICH_UPLOAD_ENDS_MOB : PAGE_WHICH_UPLOAD_ENDS)), [currentPage, isMobile]);

  // todo fix naming, seems like does the opposite
  const isCanLoadInfinityProjectsMore = useMemo(() => {
    // if (infinityProjectsPaging &&
    //     ((Number(currentPage) > infinityProjectsPaging?.pages) ||
    //     ((Number(currentPage) * PROJECTS_COUNT_FOR_OFFSET) >
    //     infinityProjectsPaging?.count))
    //   )
    // {
    //   return false;
    // }
    return isFinalPage || isOnlines;
  } , [infinityProjectsPaging, currentPage, isFinalPage])

  const filterChanged = useMemo(() => (
    !isProjectPage && (
      JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
      JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
      JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) || 
      JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
      JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
      filter?.projectFilter !== infinityProjectsFilter?.projectFilter ||
      (isTagPage && 
        (
          (filter?.isContextIgnored !== infinityProjectsFilter?.isContextIgnored ) || 
          (filter?.approved !== infinityProjectsFilter?.approved) || 
          (filter?.notApproved !== infinityProjectsFilter?.notApproved) || 
          (filter?.notModerated !== infinityProjectsFilter?.notModerated) ||
          (filter?.moderatedBy !== infinityProjectsFilter?.moderatedBy) || 
          (filter?.createdFrom !== infinityProjectsFilter?.createdFrom) ||
          (filter?.createdTo !== infinityProjectsFilter?.createdTo) ||
          (filter?.publishedFrom !== infinityProjectsFilter?.publishedFrom) ||
          (filter?.publishedTo !== infinityProjectsFilter?.publishedTo)
          )
        )
      )
    ), [infinityProjectsFilter, filter, isProjectPage, isTagPage])

  const isPrevFiltersNotEquals  = useMemo(() => {
    if (isProjectPage) {
      return (
        JSON.stringify(filter?.requestContext) !== JSON.stringify(infinityProjectsFilter?.requestContext) ||
        JSON.stringify(filter?.requiredTagIds) !== JSON.stringify(infinityProjectsFilter?.requiredTagIds) ||
        JSON.stringify(filter?.tagIds) !== JSON.stringify(infinityProjectsFilter?.tagIds) || 
        JSON.stringify(filter?.contexts) !== JSON.stringify(infinityProjectsFilter?.contexts) ||
        JSON.stringify(filter?.globalTypes) !== JSON.stringify(infinityProjectsFilter?.globalTypes) ||
        filter?.projectFilter !== infinityProjectsFilter?.projectFilter
      ) 
    }   
  }, [infinityProjectsFilter, filter, isProjectPage])


  const isInitialNeeded = useMemo(() => (
    !isProjectPage && (
      isFilterChanged( filter, infinityProjectsFilter, 'contexts') ||
      isFilterChanged(filter, infinityProjectsFilter, 'globalTypes') ||
      filter?.requestContext !== infinityProjectsFilter?.requestContext ||
      isFilterChanged(filter, infinityProjectsFilter, 'requiredTagIds') ||
      infinityProjectsFilter?.projectFilter !== filter?.projectFilter ||
      (isTagPage && 
        (
          (filter?.tagIds?.[0] !== infinityProjectsFilter?.tagIds?.[0]) ||
          (filter?.isContextIgnored !== infinityProjectsFilter?.isContextIgnored ) || 
          (filter?.approved !== infinityProjectsFilter?.approved) || 
          (filter?.notApproved !== infinityProjectsFilter?.notApproved) || 
          (filter?.notModerated !== infinityProjectsFilter?.notModerated) ||
          (filter?.moderatedBy !== infinityProjectsFilter?.moderatedBy) || 
          (filter?.createdFrom !== infinityProjectsFilter?.createdFrom) ||
          (filter?.createdTo !== infinityProjectsFilter?.createdTo) ||
          (filter?.publishedFrom !== infinityProjectsFilter?.publishedFrom) ||
          (filter?.publishedTo !== infinityProjectsFilter?.publishedTo)
        )
      )
  )
    ), [infinityProjectsFilter, filter, isTagPage, isProjectPage])

  useEffect(() => {
    setFilterType(filter?.projectFilter);
    if (filterChanged) {
      if (!withoutQueryParams) setQueryParams({ page: 1 }, { replace: true })
      if (!isOnlines) {
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset()); //Убрать если будут проблемы
      }
      if (isTagPage) {
        dispatch(InfinityProjectsActions.clear());
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter({}))
        setTemp(Date.now());
      }
      dispatch(InfinityProjectsActions.setFilter(filter));
    } 
    if (isPrevFiltersNotEquals) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
    }
    if (!disableFilterCheck) {
      setTemp(Date.now());
    }
  }, [filter, dispatch, i18n, isTagPage, filterChanged, currentTab, isPrevFiltersNotEquals, setQueryParams, withoutQueryParams])

  /**
   * Фикс бага @Artem
   */
  useEffect(() => {
    if (!isPreloadLoading && (currentTab || "") in (infinityProjectsPagingList || {})) {
      dispatch(InfinityProjectsActions.setPaging(infinityProjectsPagingList[currentTab]));
    } else if (tabRef?.current !== currentTab) {
      dispatch(InfinityProjectsActions.clearFinalPage());
    }
    tabRef.current = currentTab
  }, [currentTab, tabRef, isPreloadLoading, infinityProjectsPagingList])

  useEffect(() => {
    return () => {
      dispatch(InfinityProjectsActions.clearFinalPage());
    }
  }, [])

  /**
   * Начальная подгрузка
   */
  useEffect(() => {
    /**
     * Без табов
     */
    if (isInfinityNeed && isPageWithoutTabs && !isProjectPage) {
      if (isNeedUpdMore || isNeedUpdatePreload) {
        scrollTop();
        setRefresh(false)
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            {
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              isTagPage,
              // lang: i18n.language
            }
          )
        );
        return;
      }
      if ((isStartPage || isBackToStartPage) && !(isOnlines && infinityProjects?.length)) {
        dispatch(
          fetchInfiniteProjectsMore(
            {
              // lang: i18n.language,
              currentTab,
              page: isBackToStartPage ? NULLABLE_OFFSET : currentPage,
              exceptions: true ,
              isTagPage,
              tabs: preloadedTabs,
              contextName,
              withoutTabs: isPageWithoutTabs
            }
          )
        );
      }
    }

    /**
     * С табами
     */
    if (isInfinityNeed && preloadedTabs && !isPageWithoutTabs) {

      if (isNeedUpdMore) {
        scrollTop();
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.setIsProjectPage(true));
        dispatch(
          fetchInfiniteProjectsWithUpdate(
            { 
              page: currentPage,
              isTagPage,
              // lang: i18n.language
            }
          )
        );
      }
      if (isInitialNeeded || isBackToStartPage) {
        /**
         * Все очищаем
         */
        setRefresh(false);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        /*
         * запрашиваем прелоад проекты
         */
        dispatch(fetchInfiniteProjects({ 
          preload: preloadedTabs,
          page: currentPage,
          currentTab,
          isTagPage,
          // lang: i18n.language
        }));
        return;
        /**/
      } 
    }
  }, [
    isInitialNeeded,
    isNeedUpdMore,
    isStartPage,
    isTagPage, 
    isBackToStartPage,
    isNeedUpdatePreload, 
    dispatch,
    refresh, 
    isProjectPage, 
    currentPage, 
    i18n, 
    preloadedTabs, 
    isInfinityNeed,
    isPageWithoutTabs,
    contextName
  ])

  /**
   * Обновление при переключении табов
   */
  useEffect(() => {

    if (!isProjectPage && currentTab && !isOnlines) {
      dispatch(InfinityProjectsActions.setIsProjectPage(false));
      dispatch(InfinityProjectsActions.clearProjects());
      dispatch(InfinityProjectsActions.clearOffset());
    }
  }, [dispatch, currentTab, isProjectPage])

  const setCurrentPage = (page: any) => { setQueryParams({ page }, { replace: true }) };

  useEffect(() => {
    if (
      (!teachersOnly && teachersPrev.current) || (teachersPrev.current && !teachersOnly)
    ) {
      setCurrentPage(1);
      dispatch(InfinityProjectsActions.clear())
      setFastScrolling(false);
    }
    teachersPrev.current = teachersOnly;
  }, [
    teachersOnly,
    dispatch,
    setCurrentPage,
    setFastScrolling 
  ])

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if  (isParticipate && isParticipate.length > 0) {
      return data ? isParticipate.includes(data) : false;
    }
  }, [isParticipate])

  const fetchMoreProjectsNext= useCallback(() => {
    // if (needAutoFetchProjectsMore) return false;
      setCurrentPage(!infinityProjectsPaging.offset ? 2 : infinityProjectsPaging.offset === 20 ? 3 : ((
        //@ts-ignore
        infinityProjectsPaging.offset + PROJECTS_COUNT_FOR_OFFSET) / PROJECTS_COUNT_FOR_OFFSET) + PAGE_COUNT_STARTS
      );

      if (!isPageWithoutTabs) {
        setRefresh(false)
      }

      dispatch(fetchInfiniteProjectsMore({ 
        // lang : i18n.language,
        currentTab,
        tabs: preloadedTabs, 
        contextName,
        isTagPage, 
        withoutTabs: isPageWithoutTabs 
      }));
  }, [
    // needAutoFetchProjectsMore,
    infinityProjectsPaging,
    setCurrentPage,
    i18n,
    dispatch,
    isPageWithoutTabs,
    preloadedTabs,
    contextName
  ])

  // const ShowMoreButtonOrLoading = useMemo(() => {
  //   if( fastScrolling && needAutoFetchProjectsMore) {

  //     return (
  //       <ShowMoreWrapper 
  //         style={{ cursor: 'pointer' }}
  //         width={'80%'} 
  //         justify="center" 
  //         offsetBottom={24} 
  //         offsetTop={32}
  //         onClick={() => {
  //           setFastScrolling(false);
  //           fetchMoreProjects();
  //         }}
  //       >
  //         <FInter.TextBold 
  //           style={{ fontSize: '17px', whiteSpace: 'pre', userSelect: 'none' }} 
  //           color={theme.progressbar.colorBold}>
  //           {t('text.show_more')}
  //         </FInter.TextBold >
  //       </ShowMoreWrapper>
  //     )
  //   }

  //   return (
  //     <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
  //       <ProgressBar 
  //         text={t('text.loading')} 
  //         loading={true} 
  //         color={theme.progressbar.color} 
  //       />
  //     </FlexBox>
  //   )
  // }, [fastScrolling, setFastScrolling, t, fetchMoreProjects, theme, needAutoFetchProjectsMore])

  const ShowMoreButtonOrLoading = useMemo(() => {

    if (!infinityProjectsLoading) {
      return null;
    }

    return (
      <FlexBox direction='column' directionMobile='column'>
        <GridWrapperNew mobileColumns={2}>
          {new Array(8).fill('').map((_, index) => (
              <SkeletonCard key={index}/>
          ))}
        </GridWrapperNew>
        <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
          <ProgressBar 
            text={t('text.loading')} 
            loading={true} 
            color={theme.progressbar.color} 
          />
        </FlexBox>
      </FlexBox>
    )
  }, [t, theme, infinityProjectsLoading])


  const paging = useMemo(() => {
      return isInfinityNeed ? infinityProjectsPaging : projects?.paging
  }, [isInfinityNeed, infinityProjectsPaging, projects]);

  const sortedProjects = useMemo(() => isOnlines ? projects?.data?.sort((a, b) => {
    if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] > ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
      return 1;
    }
    if (ONLINES_PROJECT_ORDER_INDEX[a.projectId] < ONLINES_PROJECT_ORDER_INDEX[b.projectId]) {
      return -1;
    }
    return 0;
  }) : projects?.data, [isOnlines, projects]);

  const localizedInfinityProjectsWithPreload = useMemo(() => {
    return infinityProjectsWithPreload ? API.toLang(infinityProjectsWithPreload, i18n.language) : []
  }, [infinityProjectsWithPreload, i18n.language])

  return (
    <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
      {!showInfinityScroll && (
        <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading || courseLoading} columns={columns}>
        {sortedProjects?.map((v: Nullable<Partial<Project<'Local'>>>) => {
          /**
           * Нурс попоросил убрать проект с онлайнс 
           */
          if (isOnlines && v?.projectId === "b1e7ff644881488c9d90508feb43aaec") {
            return false;
          }
          if (!v?.isBook) {
            return (
              <ProjectCardNew
                project={v as any}
                isSortedByNotModerated={isSortedByNotModerated}
                isModal={modal}
                withoutGoToProject={withoutGoToProject}
                onProjectClick={ modal ?
                  (projectId?: string, e?: any) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    if (!v?.isBook) {
                      show('project', { projectId: v?.projectId });
                    }
                  } : undefined }
                isSelectable={selectable}
                isEditable={
                  !isAgeyTomesh &&
                  ((v && designer && bProject?.isEditableFor(v as any, designer)) ||
                  bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any))
                }
                isRejected={ProjectDelegate.isRejectedProject(v)}
                key={v?.projectId}
                {...computeProject(v)}
                onShouldReload={() => setTemp(Date.now())}
                onSelect={onSelect}
                metaAlwaysVisible={selectedProjects?.includes(v?.projectId ?? '')}
                selected={selectedProjects?.includes(v?.projectId ?? '')}
                alreadyProject={isAlreadyProject(v?.projectId)}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isSelectRightNeed={isSelectRightNeed}
                showCompetitionPoint={showCompetitionPoint}
                canMakeImageForTeam={canMakeImageForTeam}
              />
            );
        } else {
          const book = computeBookProject(v);
          return (
            <BookCard
              book={book as any}
              key={book?.bookId}
              {...computeBook(book)}
              onShouldReload={() => setTemp(Date.now())}
              linkPrefix={linkPrefix ? linkPrefix : undefined}
              isSortedByNotModerated={isSortedByNotModerated}
              onSelect={onSelect}
              selected={selectedProjects?.includes(v?.projectId ?? '')}
            />
          );
        }
      })}
      </ProjectsGridNew>
      )}

      {showInfinityScroll && (
        <InfiniteScroll
        //@ts-ignore
            dataLength={localizedInfinityProjectsWithPreload?.length}
            next={fetchMoreProjectsNext}
            hasMore={!isCanLoadInfinityProjectsMore}
            initialScrollY={0}
            scrollThreshold={0.9}
            loader={ShowMoreButtonOrLoading}
            ref={infScrollRef}
          >
            <ProjectsGridNew k={isMainPage ? 20 : undefined} isLoading={isProjectsLoading || isPreloadLoading || courseLoading} columns={columns}>
              {/*@ts-ignore*/}
              {localizedInfinityProjectsWithPreload?.map((v: Nullable<Partial<Project<'Local'>>>) => {
                if (!v?.isBook) {
                  return (
                    <ProjectCardNew
                      project={v as any}
                      isSortedByNotModerated={isSortedByNotModerated}
                      isModal={modal}
                      withoutGoToProject={withoutGoToProject}
                      onProjectClick={modal ?
                        (projectId?: string, e?: any) => {
                          e?.stopPropagation();
                          e?.preventDefault();
                          // show('project', { projectId: v?.projectId });
                        } : undefined }
                      isSelectable={selectable}
                      isEditable={
                        !isAgeyTomesh &&
                        ((v && designer && bProject.isEditableFor(v as any, designer)) ||
                        bProfile.isModer(designer as any) || bProfile.isMiddleModer(designer as any))
                      }
                      isRejected={ProjectDelegate.isRejectedProject(v)}
                      key={v?.projectId}
                      {...computeProject(v)}
                      onShouldReload={() => setTemp(Date.now())}
                      onSelect={onSelect}
                      selected={selectedProjects?.includes(v?.projectId ?? '')}
                      alreadyProject={isAlreadyProject(v?.projectId)}
                      linkPrefix={linkPrefix ? linkPrefix : undefined}
                      showCompetitionPoint={showCompetitionPoint}
                      canMakeImageForTeam={canMakeImageForTeam}
                    />
                  );
                } else {
                  const book = computeBookProject(v);
                  return (
                    <BookCard
                      book={book as any}
                      key={book?.bookId}
                      {...computeBook(book)}
                      onShouldReload={() => setTemp(Date.now())}
                      linkPrefix={linkPrefix ? linkPrefix : undefined}
                      isSortedByNotModerated={isSortedByNotModerated}
                      onSelect={onSelect}
                      selected={selectedProjects?.includes(v?.projectId ?? '')}
                    />
                  );
                }
              })}
            </ProjectsGridNew>
        </InfiniteScroll>
      )}
      {isInfinityNeed && !isPageWithoutTabs && (
          <EmptyCardsLoading k={isMainPage ? 0 : 8} isLoading={isPreloadLoading} />
      )}
      {/* {(isInfinityNeed && needAutoFetchProjectsMore) && (
        <ShowMoreProjectsBlock 
          onClick={() => {
            setFastScrolling(false);
            fetchMoreProjects();
          }} 
          hide={infinityProjectsLoading} 
        />
      )} */}
      {!isInfinityNeed && (
        <Pagination
          pages={paging?.pages ?? 0}
          page={Number(currentPage)}
          onPageChange={(page) => {
            setQueryParams({ page }, { replace: true });
            isInfinityNeed && setRefresh(true)
            isPageWithoutTabs && dispatch(
              InfinityProjectsActions.setIsProjectPage(false)
            );
            setTemp(Date.now());
            scrollTop();
          }}
          isCanLoadMore={currentPage < (paging?.pages ?? 0)}
          hidden={(!paging?.pages || paging?.pages === 1)}
        /> 
      )}
      {/* <OffsetBlock display={(!paging?.pages || paging?.pages === 1)} /> */}
    </FlexBox>
  );
});
